import { Navigate } from 'react-router-dom'
import { HOME_ROUTE } from '../../../app/router/routes'
import { useAppSelector } from '../../../app/store/store'
import { FEATURES, hasFeatureGrant } from '../../../entities/my'
import { StudentsArchive } from '../../../widgets/studentsArchive'

export default function StudentsArchivePage() {

    const {my} = useAppSelector(s => s.myReducer)

    const isAccess = hasFeatureGrant(my, FEATURES.FRONT.STUDENT_ARCHIVE)
    
    if(!isAccess){
        return (
            <Navigate to={HOME_ROUTE.path} replace />
        )
    }

    return (
        <StudentsArchive />
    )
}
